import React, { useEffect, useState } from 'react'


import '../CSS/galery.css'

const req = require.context('../image/zimer/', false, /\.webp$/);
const images = req.keys().map(req);





function Galery() {

  let [curent, setCurent] = useState(0);
  let [back, setBack] = useState(images.length - 1);
  let [next, setNext] = useState(curent + 1);
  let [id, setId] = useState(0);


  let flag = true;

  useEffect(() => {

    if (flag) {
      setId(setInterval(nextPic, 5000));
      console.log(id);
      flag = false;
    }

  }, []);


  const backPic = () => {
    back = curent;
    curent++;
    if (curent >= images.length) {
      curent = 0;
    }

    if (curent < images.length - 1) {
      next = curent + 1;
    } else {
      next = 0;
    }

    setBack(back);
    setCurent(curent);
    setNext(next);

  }

  const nextPic = () => {
    next = curent;
    curent--;

    if (curent <= -1) {
      curent = images.length - 1;
    }

    if (curent <= 0) {
      back = images.length - 1;
    } else {
      back = curent - 1;
    }

    setBack(back);
    setCurent(curent);
    setNext(next);

  }

  const bigImg = (e) => {
    console.log(id);
    clearInterval(id);
    let elem = e.target;
    console.log(elem);
  }


  return (
    <div className='container' id="galery">
      <h2>גלריה</h2>
      <div id='picContainer'>
        <button className='btnImgGalery' onClickCapture={backPic} id='btnBack'>הקודם</button>
        <div id='galeryPic'>
          <img defaultValue={"צימר רוני"} onClickCapture={bigImg} className='secImg' id='imgA' src={images[back]} alt="צימר רוני" />
          <img defaultValue={"צימר רוני"} className='firImg' id='imgB' src={images[curent]} alt="צימר רוני" />
          <img defaultValue={"צימר רוני"} className='secImg' id='imgC' src={images[next]} alt="צימר רוני" />
        </div>
        <button  className='btnImgGalery' onClickCapture={nextPic} id='btnNext'>הבא</button>
      </div>
      
    </div>
  )
}

export default Galery